import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const EntregaServicioClienteRACI = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/06-entrega-de-servicios-a-cliente-RACI.pdf`;
  /*const pdfUrl = "/pdf/06-entrega-de-servicios-a-cliente-RACI.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Entrega de Servicio a Cliente Matriz RACI</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Entrega de Servicio a Cliente Matriz RACI" />
      </Container>
    </>
  );
};

 export default EntregaServicioClienteRACI;
